/* dashboard.icon.svg.js */

'use strict';
module.exports = {
    icon: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 768 768">
    <title></title>
    <path class="foreground-gl" d="M95.999 416.002h256v-320h-256v320zM95.999 672.001h256v-192.001h-256v192.001zM416.002 672.001h256v-319.999h-256v319.999zM416.002 95.999v192.001h256v-192.001h-256z"></path>
    </svg>
    `
};